/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import brAxios from 'Api/Interceptors';

export const ErrorApi = {
  getError: () => brAxios.get('/posts'),
};
